import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
export const navTabsWrapper = "odules__Featured__components__NavTabs__styles_new_ts-navTabsWrapper-n1cvk9p9";
export const navTabsList = "odules__Featured__components__NavTabs__styles_new_ts-navTabsList-n1s8h0yn";
export const navTab = "odules__Featured__components__NavTabs__styles_new_ts-navTab-n15lvx2g";

require("./styles.new.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.new.ts");